import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useUserPaymentMethodsQuery = createQueryHook(PaymentApiClient.getUserPaymentMethods, {
  queryKey: ['userPaymentMethods'],
})
